import axios from 'axios'
import {getAdminToken} from '../auth/_requests'

const API_URL = process.env.REACT_APP_API_URL

const adminApi = axios.create({withCredentials: true})
adminApi.interceptors.request.use((config) => {
  const token = getAdminToken()
  if (token && config.headers) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

export interface LoginAttemptRow {
  _id: string
  method: 'password' | 'phone_send' | 'phone_verify' | 'facebook' | 'google'
  identifier: string
  account?: {
    _id: string
    first_name?: string
    last_name?: string
    email?: string
    username?: string
    phone?: string
  } | null
  success: boolean
  reason: string
  ip: string
  user_agent: string
  created_at: string
}

export interface LoginAttemptsResponse {
  success: boolean
  attempts: LoginAttemptRow[]
  pagination: {page: number; limit: number; total: number; pages: number}
  summary: {
    total: number
    success: number
    failed: number
    by_method: Record<string, {total: number; success: number; failed: number}>
  }
  window_days: number
}

export function getLoginAttempts(params: {
  page?: number
  limit?: number
  method?: string
  success?: string
  search?: string
  days?: number
}): Promise<{data: LoginAttemptsResponse}> {
  return adminApi.get(`${API_URL}/admin/login-attempts`, {params})
}
